export const AUTH_CALLBACK_PATH = '/auth/callback';
export const HOME_PATH = '/';
export const LOGIN_PATH = '/login';
